import { useEffect, useState, useCallback } from 'react';
import styles from './AdminActivity.module.css';
import LoadMoreButton from './components/LoadMoreButton';

const EVENT_OPTIONS = [
  '', 'auth.signup', 'auth.login', 'auth.logout',
  'auth.email_verified', 'auth.verify_email_request',
  'auth.password_reset_request', 'auth.password_reset_complete', 'auth.password_change',
  'page.view',
  'admin.grant_access', 'admin.revoke_access', 'admin.grant_admin', 'admin.revoke_admin',
  'admin.category_change', 'admin.scrap_trigger', 'admin.review_query', 'admin.detail_query',
  'review_query',
];

export default function AdminActivity() {
  const [items, setItems] = useState([]);
  const [eventFilter, setEventFilter] = useState('');
  const [userFilter, setUserFilter] = useState('');
  const [cursor, setCursor] = useState(null);
  const [hasMore, setHasMore] = useState(false);

  const load = useCallback(async (reset = false) => {
    const params = new URLSearchParams();
    if (eventFilter) params.set('event', eventFilter);
    if (userFilter) params.set('user_id', userFilter);
    if (!reset && cursor) params.set('cursor', String(cursor));
    params.set('limit', '50');

    const res = await fetch('/api/admin/activity?' + params.toString(), { credentials: 'include' });
    if (!res.ok) return;
    const data = await res.json();
    setItems(prev => reset ? data.data : [...prev, ...data.data]);
    setCursor(data.next_cursor);
    setHasMore(!!data.next_cursor);
  }, [eventFilter, userFilter, cursor]);

  useEffect(() => {
    setCursor(null);
    load(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventFilter, userFilter]);

  return (
    <div className={styles.wrap}>
      <div className={styles.filters}>
        <select className={styles.select} value={eventFilter} onChange={e => setEventFilter(e.target.value)}>
          {EVENT_OPTIONS.map(ev => <option key={ev} value={ev}>{ev || '(모든 이벤트)'}</option>)}
        </select>
        <input
          className={styles.input}
          placeholder="user_id (선택)"
          value={userFilter}
          onChange={e => setUserFilter(e.target.value)}
        />
      </div>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>시간</th>
            <th>사용자</th>
            <th>이벤트</th>
            <th>Target</th>
            <th>Metadata</th>
            <th>IP</th>
          </tr>
        </thead>
        <tbody>
          {items.map(r => (
            <tr key={r.id}>
              <td>{new Date(r.created).toLocaleString()}</td>
              <td>{r.email || `#${r.user_id ?? 'anon'}`}</td>
              <td className={styles.event}>{r.event}</td>
              <td>{r.target || '-'}</td>
              <td className={styles.meta}>{r.metadata ? JSON.stringify(r.metadata) : '-'}</td>
              <td>{r.ip || '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <LoadMoreButton hasMore={hasMore} onClick={() => load(false)} />
    </div>
  );
}
